import { render } from "./component-payer-additional-acc-ul.vue?vue&type=template&id=74a025b4"
import script from "./component-payer-additional-acc-ul.vue?vue&type=script&setup=true&lang=js"
export * from "./component-payer-additional-acc-ul.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payer-additional-acc-ul.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74a025b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74a025b4', __exports__)) {
    api.reload('74a025b4', __exports__)
  }
  
  module.hot.accept("./component-payer-additional-acc-ul.vue?vue&type=template&id=74a025b4", () => {
    api.rerender('74a025b4', render)
  })

}


export default __exports__